import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Grid,
  ListItem,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { IEmployeeWorkshopData } from "models/workshop";
import React, { useState } from "react";
import AddLocationIcon from '@mui/icons-material/AddLocation';
import EventIcon from '@mui/icons-material/Event';
import { useTranslation } from "react-i18next";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import DateDisplay from "./partials/DateDisplay";
import DateDisplay2 from "./partials/DateDisplay2";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useMutation } from "react-query";
import { formatDate } from "helpers";
interface Props {
  workshop: IEmployeeWorkshopData;
  activeTab: string;
  handleEnroll: (id: string) => void;
  handleWithdraw: (id: string) => void;
  handleDeleteWaitingList: (id: string) => void;
  handleSendInvitations: (id: string, status: number) => void;
}

const EmployeeWorkshopCard: React.FC<Props> = ({ workshop, activeTab, handleEnroll, handleWithdraw, handleDeleteWaitingList, handleSendInvitations }) => {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");
  const [expanded, setExpanded] = useState<boolean>(false);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const handleToggle = () => setExpanded(!expanded);

  const currDate = new Date();
  currDate.setDate(currDate.getDate() - 1);

  return (

    <Accordion
      expanded={expanded}
      style={{ boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}
    >
      <AccordionSummary
        aria-controls="panel1-content"
        id="panel1-header"
        sx={{
          marginBottom: "8px",
          padding: { xs: '8px', sm: '12px', lg: '16px' },
          backgroundColor: "#fff",
          borderRadius: "8px",
          cursor: 'default',
        }}
      >
        <Grid container spacing={2} alignItems="flex-start"
          onClick={() => {
    if (activeTab !== 'openWorkshops') {
      navigate(
        `${workshop.id}${workshop.invitationId ? `?invitationId=${workshop.invitationId}&tab=${tab}` : `?tab=${tab}`}`
      );
    }
  }}>
          <Grid item xs={12} sm={8}>
            <Box
              sx={{
                display: "flex",
                gap: 2.5, // Directly using the value without the need for theme.spacing() if you don't need theme-aware spacing
                alignItems: "center",
                flexDirection: { xs: "column", sm: "row" }, // Use MUI breakpoints directly
              }}
            >
              <DateDisplay toDate={formatDate(workshop.fromDate)} />
              <ListItem
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: 1,
                }}
              >
                <Typography variant="h4" color={'#9c3e9c'} sx={{ fontSize: { xs: '20px', sm: '28px' } }}>
                  {i18n.language === "en"
                    ? workshop.topicName
                    : workshop.topicNameAr}
                </Typography>

                {workshop.venueName && workshop.topicName && (
                  <Typography
                    variant="body1"
                    color={'#6366f1'}
                    fontWeight={'500'}
                    sx={{ fontSize: { xs: '12px', sm: '16px' } }}
                  >
                    {i18n.language === "en"
                      ? workshop.venueName
                      : workshop.venueNameAr}{" "}
                    -{" "}
                    {i18n.language === "en"
                      ? workshop.topicName
                      : workshop.topicNameAr}
                  </Typography>
                )}


                {/* <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 2,
                    '& span': {
                      fontFamily: 'Arial, sans-serif',
                      color: '#004400',
                      fontSize: { xs: '12px', sm: '16px' },
                    },
                  }}
                >
                  <EventIcon sx={{ fontSize: { xs: 16, sm: 20 } }} />
                  <DateDisplay2 toDate={formatDate(workshop.fromDate)} />
                  <span>{workshop.fromTime || "00:00"}</span>
                  <span>-</span>
                  <DateDisplay2 toDate={workshop.toDate} />
                  <span>{workshop.toTime || "00:00"}</span>
                </Box> */}

                <Box
                  sx={{
                    display: 'flex',
                    my:1,
                    flexDirection:'column',
                    gap: 1,
                    '& span': {
                      fontFamily: 'Arial, sans-serif',
                      color: '#004400',
                      fontSize: { xs: '12px', sm: '16px' },
                    },
                  }}
                >
                  <Stack direction={'row'} alignItems={'center'} gap={2} sx={{ fontSize: { xs: '12px', sm: '16px' } }}>
                <Typography variant="body1" sx={{ color: "#555", fontWeight: 500 }}>
                  Date:
                </Typography>
                <Typography variant="body2" sx={{ color: "#888" }}>
                  {workshop.dates}
                </Typography>
              </Stack>
                <Stack direction={'row'} alignItems={'center'} gap={2} sx={{ fontSize: { xs: '12px', sm: '16px' } }}>
                <Typography variant="body1" sx={{ color: "#555", fontWeight: 500 }}>
                  Time:
                </Typography>
                <Typography variant="body2" sx={{ color: "#888" }}>
                  {workshop.time}
                </Typography>
              </Stack>
                <Stack direction={'row'} alignItems={'center'} gap={2} sx={{ fontSize: { xs: '12px', sm: '16px' } }}>
                <Typography variant="body1" sx={{ color: "#555", fontWeight: 500 }}>
                  Total Duration:
                </Typography>
                <Typography variant="body2" sx={{ color: "#888" }}>
                  {workshop.totalDuration}
                </Typography>
              </Stack>
                
                </Box>

                {workshop.cityName && workshop.venueName && workshop.roomNumber && (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'center' }}>
                    <AddLocationIcon sx={{ fontSize: { xs: 16, sm: 20 } }} /> {/* Smaller icon on smaller screens */}
                    <span style={{ fontSize: '14px', lineHeight: '1.5' }}>
                      {workshop.cityName}, {workshop.venueName}, {workshop.roomNumber}
                    </span>
                  </div>
                )}

                <Typography variant="subtitle2" sx={{ color: "#555", fontWeight: 500, fontSize: { xs: '12px', sm: '16px' }, }}>
                  {`${workshop.remainingSeats || 0} Seats Available`}
                </Typography>
              </ListItem>
            </Box>
          </Grid>

          <Grid item xs={12} sm={4} container direction="column" alignItems="flex-end" gap={1} sx={{ marginTop: 'auto' }}>
            {workshop.canEnroll && ((activeTab == 'waitingListWorkshops' || activeTab == 'openWorkshops') && workshop.remainingSeats > 0) && (
              <Button
                variant="contained"
                color="success"
                sx={{ textTransform: "none", borderRadius: 0 }}
                onClick={() => handleEnroll(workshop.id)}
              >
                {t("T_enroll")}
              </Button>
            )}

            {workshop.canEnroll && (activeTab == 'openWorkshops' && workshop.remainingSeats == 0) && (
              <Button
                variant="contained"
                color="success"
                sx={{ textTransform: "none", borderRadius: 0 }}
                onClick={() => handleEnroll(workshop.id)}
              >
                {t("T_add_to_waiting_list")}
              </Button>
            )}

            {/* {workshop.canWithdraw && (activeTab == 'enrolledWorkshops' || activeTab == 'waitingListWorkshops') && (
              <Button
                variant="contained"
                color="error"
                sx={{ textTransform: "none", borderRadius: 0 }}
                onClick={() => activeTab == 'enrolledWorkshops' ? handleWithdraw(workshop.id) : handleDeleteWaitingList(workshop.id)}
              >
                {t("T_withdraw")}
              </Button>
            )} */}

            {workshop.enrollmentStatus === null &&  activeTab === 'invitedWorkshops' ? <div style={{ display: 'flex', gap: 5 }}>
              {workshop.canEnroll === true && <Button
                variant="contained"
                color="success"
                sx={{ textTransform: "none", borderRadius: 0 }}
                onClick={() => handleSendInvitations(workshop.invitationId, 1)}
              >
                {t("T_accept")}
              </Button>}
              {workshop.canReject && <Button
                variant="contained"
                color="error"
                sx={{ textTransform: "none", borderRadius: 0 }}
                onClick={() => handleSendInvitations(workshop.invitationId, 2)}
              >
                {t("T_reject")}
              </Button>}
            </div> :
              <Typography variant="subtitle2" sx={{ color: "#555", fontWeight: 500, fontSize: { xs: '12px', sm: '16px' }, }}>
                {workshop.enrollmentStatus}
              </Typography>
            }


            {activeTab === 'openWorkshops'
              ? null
              : (
                <Link
                  to={`${workshop.id}${workshop.invitationId ? `?invitationId=${workshop.invitationId}&tab=${tab}` : `?tab=${tab}`}`}
                  style={{ marginBottom: 8 }}
                >
                  <Button variant="contained" style={{ borderRadius: 0 }} sx={{ fontSize: { xs: '12px', sm: '16px' } }}>
                    See Details
                  </Button>
                </Link>

              )}
            <Button
              variant="text"
              onClick={(e)=>{e.stopPropagation();handleToggle()}}
              startIcon={expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              sx={{ textTransform: "none", marginTop: 'auto', fontSize: { xs: '12px', sm: '16px' } }}
            >
              {expanded ? "Less" : "More"}
            </Button>
          </Grid>
        </Grid>
      </AccordionSummary>


      <AccordionDetails>
        <Box sx={{ padding: " 0 16px" }}>
          <Grid container spacing={2} >
            {workshop.learningOutcome && (
              <Grid item xs={12} sx={{ fontSize: { xs: '12px', sm: '16px' } }}>
                <Typography variant="body1" sx={{ color: "#555", fontWeight: 500 }}>
                  Learning Outcome:
                </Typography>
                <Typography variant="body2" sx={{ color: "#888" }}>
                  {workshop.learningOutcome}
                </Typography>
              </Grid>
            )}
            {workshop.companyName && (
              <Grid item xs={12} sm={6} sx={{ fontSize: { xs: '12px', sm: '16px' } }}>
                <Typography variant="body1" sx={{ color: "#555", fontWeight: 500 }}>
                  Organized by:
                </Typography>
                <Typography variant="body2" sx={{ color: "#888" }}>
                  {workshop.companyName}
                </Typography>
              </Grid>
            )}
            {workshop.vendorName && (
              <Grid item xs={12} sm={6} sx={{ fontSize: { xs: '12px', sm: '16px' } }}>
                <Typography variant="body1" sx={{ color: "#555", fontWeight: 500 }}>
                  Delivered by:
                </Typography>
                <Typography variant="body2" sx={{ color: "#888" }}>
                  {workshop.vendorName}
                </Typography>
              </Grid>
            )}
            {workshop.cityName && workshop.venueName && workshop.roomNumber && (
              <Grid item xs={12} sm={6} sx={{ fontSize: { xs: '12px', sm: '16px' } }}>
                <Typography variant="body1" sx={{ color: "#555", fontWeight: 500 }}>
                  Location:
                </Typography>
                <Typography variant="body2" sx={{ color: "#888" }}>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'center' }}>
                    <span style={{ fontSize: '14px', lineHeight: '1.5' }}>
                      {workshop.cityName}, {workshop.venueName}, {workshop.roomNumber}
                    </span>
                  </div>
                </Typography>

              </Grid>
            )}
            {/* {workshop.topicName && (
              <Grid item xs={12} sm={6} sx={{ fontSize: { xs: '12px', sm: '16px' } }}>
                <Typography variant="body1" sx={{ color: "#555", fontWeight: 500 }}>
                  Topic Name:
                </Typography>
                <Typography variant="body2" sx={{ color: "#888" }}>
                  {workshop.topicName}
                </Typography>
              </Grid>
            )} */}

            {workshop.trainer && (
              <Grid item xs={12} sm={6} sx={{ fontSize: { xs: '12px', sm: '16px' } }}>
                <Typography variant="body1" sx={{ color: "#555", fontWeight: 500 }}>
                  Trainer:
                </Typography>
                <Typography variant="body2" sx={{ color: "#888" }}>
                  {workshop.trainer}
                </Typography>
              </Grid>
            )}
            {workshop.roomNumber && (
              <Grid item xs={12} sm={6} sx={{ fontSize: { xs: '12px', sm: '16px' } }}>
                <Typography variant="body1" sx={{ color: "#555", fontWeight: 500 }}>
                  Room Number:
                </Typography>
                <Typography variant="body2" sx={{ color: "#888" }}>
                  {workshop.roomNumber}
                </Typography>
              </Grid>
            )}

            {workshop.trainerBiography && (
              <Grid item xs={12} sx={{ fontSize: { xs: '12px', sm: '16px' } }}>
                <Typography variant="body1" sx={{ color: "#555", fontWeight: 500 }}>
                  Trainer Biography:
                </Typography>
                <Typography variant="body2" sx={{ color: "#888" }}>
                  {workshop.trainerBiography}
                </Typography>
              </Grid>
            )}

          </Grid>
        </Box>
      </AccordionDetails>
    </Accordion>

  );
};

export default EmployeeWorkshopCard;
